module.exports = __webpack_public_path__ + "img/icon-interactions.57c9e0bb.svg";